import React from 'react'

import { Text, TextProps } from '@mantine/core'
import cn from 'classnames'

import styles from './CustomIcon.module.scss'

export type CustomIconProps = Omit<TextProps, 'children'> & {
  icon: `icon-${string}`
  fixedWidth?: number
  color?: TextProps['c']
}

export const CustomIcon = React.forwardRef<HTMLDivElement, CustomIconProps>(
  ({ icon, className, fixedWidth, color, ...textProps }, ref) => {
    const wrapperClasses = cn(className, styles.customIcon)

    return (
      <Text
        {...textProps}
        c={color ?? textProps.c}
        ref={ref}
        className={wrapperClasses}
        style={{
          width: fixedWidth,
        }}
      >
        <i className={cn(styles.icomoonIcon, icon)} />
      </Text>
    )
  },
)

CustomIcon.displayName = 'CustomIcon'
